import { render } from "./SlideTimer.vue?vue&type=template&id=1918da2a&scoped=true"
import script from "./SlideTimer.vue?vue&type=script&lang=js"
export * from "./SlideTimer.vue?vue&type=script&lang=js"

import "./SlideTimer.vue?vue&type=style&index=0&id=1918da2a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1918da2a"]])

export default __exports__